module.exports = __webpack_public_path__ + "static/media/lapremiere.949ab1a2.png";